<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Edit customer"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Edit Customer Details'"
    [altColor]="false"
    style="width: 300px"
  >
  </aw-divider>
  @if (customerInfo) {
  <div>
    <div class="form-container">
      @for (item of customerTextForms(); track $index) {
      <app-aw-text-form
        class="input"
        [readOnly]="item.readOnly"
        [required]="item.required"
        [title]="item.title"
        [value]="item.value"
        (textEntry)="item.textEntryActionHandler($event)"
      ></app-aw-text-form>
      }

      <!-- Customer Status Field -->
      <app-aw-dropdown-form
        class="input"
        [options]="statusOptions()"
        title="Status"
        [label]="customerStatusInput"
        (currentOption)="onCustomerStatusSelected($event)"
      ></app-aw-dropdown-form>
    </div>

    @if (userPermissions['isAdministrator']) {
    <div class="client-secret-table" style="padding-top: 2rem;">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Customer Secrets'"
        [altColor]="false"
        [altColor]="true"
      >
      </aw-divider>
      <div class="table-form-container" [ngClass]="container_theme()">
        <Button AwButton (click)="openAddCustomerSecretDialog = true"
          >Add</Button
        >
      </div>
      <aw-table
        [columnsDefinition]="secretsColumnsDefinition"
        [tableData]="secretsTableData()"
        [sortDisabled]="false"
      >
      </aw-table>
      <aw-dialog
        [visible]="openAddCustomerSecretDialog"
        [formFieldsData]="formFieldsData()"
        [dialogOptions]="addSecretDialogOptions()"
        (primaryAction)="addCustomerSecretFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('add')"
        ariaLabel="Add client secret"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openDeleteCustomerSecretDialog"
        [dialogOptions]="deleteSecretDialogOptions()"
        (primaryAction)="deleteCustomerSecretFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('delete')"
        ariaLabel="Delete client secret"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openClientSecretDialog"
        [formFieldsData]="clientSecretFormFields"
        [dialogOptions]="clientSecretDialogOptions()"
        (primaryAction)="dialogFormCloseHandler('client-secret')"
        ariaLabel="Client secret created"
      >
      </aw-dialog>
    </div>
    }
  </div>
  }
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
